import * as searchGuidelineTypes from '../action-types/searchGuidelineActionTypes';

const initialState = {
  initialSearch: false,
  queryData: [],
  queryValue: '',
  autoSuggestloading: false,
  suggestions: [],
  selectedUniqueId: '',
  selectedTitle: '',
  reportData: [],
  indexingData: [],
  resultData: {},
  reportNotFound: false,
  loading: false,
  error: false,
  errorMsg: '',
  user: null,
  statusId: '',
  indexingStatus: '',
  inputGuidelineId: '',
  value: '',
  selectedTerms: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case searchGuidelineTypes.UPDATE_INPUT_ID:
      return {
        ...state,
        inputGuidelineId: action.value,
        value: '',
      };

    case searchGuidelineTypes.UPDATE_STATUS_ID:
      return {
        ...state,
        statusId: action.value,
      };

    case searchGuidelineTypes.UPDATE_INPUT_TITLE:
      return {
        ...state,
        value: action.value,
        inputGuidelineId: '',
      };

    case searchGuidelineTypes.CLEAR_SUGGESTIONS:
      return {
        ...state,
        suggestions: [],
      };

    case searchGuidelineTypes.LOAD_SUGGESTIONS_BEGIN:
      return {
        ...state,
        autoSuggestloading: true,
      };

    case searchGuidelineTypes.LOAD_SUGGESTIONS_FAILED:
      return {
        ...state,
        autoSuggestloading: false,
      };

    case searchGuidelineTypes.MAYBE_UPDATE_SUGGESTIONS:
      if (action.value !== state.value) {
        return {
          ...state,
          autoSuggestloading: false,
        };
      }

      return {
        ...state,
        suggestions: action.suggestions,
        autoSuggestloading: false,
      };

    case searchGuidelineTypes.FETCH_GUIDELINE_STARTED: {
      return {
        ...state,
        loading: true,
      };
    }

    case searchGuidelineTypes.FETCH_GUIDELINE_SUCCEEDED: {
      return {
        ...state,
        reportData: action.value,
        loading: false,
        reportNotFound: false,
      };
    }

    case searchGuidelineTypes.FETCH_GUIDELINE_FAILED: {
      return {
        ...state,
        reportNotFound: true,
        loading: false,
      };
    }

    case searchGuidelineTypes.FETCH_INDEXING_STARTED: {
      return {
        ...state,
        loading: true,
      };
    }

    case searchGuidelineTypes.FETCH_INDEXING_SUCCEEDED: {
      return {
        ...state,
        resultData: action.value,
        reportNotFound: false,
        loading: false,
      };
    }

    case searchGuidelineTypes.FETCH_INDEXING_FAILED: {
      return {
        ...state,
        reportNotFound: true,
        loading: false,
      };
    }

    case searchGuidelineTypes.SAVE_INDEXING_STARTED: {
      return {
        ...state,
        loading: true,
      };
    }

    case searchGuidelineTypes.SAVE_INDEXING_SUCCEEDED: {
      return {
        ...state,
        resultData: action.resultData,
        reportNotFound: false,
        loading: false,
      };
    }

    case searchGuidelineTypes.SAVE_INDEXING_FAILED: {
      return {
        ...state,
        reportNotFound: true,
        loading: false,
      };
    }
    case searchGuidelineTypes.FETCH_TERMS_STARTED: {
      return {
        ...state,
        loading: true,
      };
    }
    case searchGuidelineTypes.FETCH_TERMS_SUCCEEDED: {
      return {
        ...state,
        selectedTerms: action.value,
        reportNotFound: false,
        loading: false,
      };
    }
    case searchGuidelineTypes.FETCH_TERMS_FAILED: {
      return {
        ...state,
        reportNotFound: true,
        loading: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
